import React, { useState, useEffect } from "react";
import SBoardMessageList from "../SBoardMessage";
import {
  IonAvatar,
  IonButton,
  IonCard,
  IonCardContent,
  IonItem,
} from "@ionic/react";
import "../SBoardMessage.scss";
import { messageResultInterface } from "../SBoardMessage.modal";
import { useToast } from "@agney/ir-toast";
import { getMessageService } from "../SBoardMessage-service";
import { MessageDataModel } from "../models/MessageData.model";
import { RolePermissionData } from "../../../../../../../../../models";
import { statusBoardService } from "../../../../../../../StatusBoard.service";
import { utilService } from "../../../../../../../../../services";

interface ContainerProps {
  messageData: MessageDataModel;
  updateMessageList: (data: any) => void;
  permissions: RolePermissionData;
}

const SBoardMessageCard: React.FC<ContainerProps> = (props) => {
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const Toast = useToast();

  useEffect(() => {
    // getMessageService.getMessage(props.messageData);

  }, []);

  async function onRemoveMesageCard() {
    let apiParams = getRemoveMessageDataParams();
    setLoaderStatus(true);
    const removecardlist: messageResultInterface = await getMessageService.funcremoveMessageCard(
      apiParams
    );
    if (removecardlist.isSuccess) {
      props.updateMessageList(removecardlist.result?.data);
      Toast.success("Message removed successfully");
    } else {
      getMessageService.handleErrorResponse();
    }
    setLoaderStatus(false);
  }

  const getRemoveMessageDataParams = () => {
    const apiParams = {
      msgid: props.messageData.id,
      pid:
        statusBoardService.rowData && statusBoardService.rowData.pid
          ? statusBoardService.rowData.pid
          : "",
      reg_code: utilService.getNetwork(),
    };
    return apiParams;
  };

  return (
    <IonCard className="sb-message-card">
      <IonCardContent>
        <div className="sb-message-date">{utilService.getDateAndTime(props.messageData.createdOn)}</div>

        <IonItem lines="none">
          <div className="message-profile-image">
            <IonAvatar>
              <img
                src={props?.messageData?.FromUser?.profilePic}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src =
                    "assets/images/defaultProfilePic.png";
                }}
                alt="Ionic logo"
              />
            </IonAvatar>
          </div>

          <div className="sb-message-content">
            <div className="sb-message-fromuser">
              From :
                {" "}
                {props.messageData.FromUser.firstName}{" "}
                {props.messageData.FromUser.lastName}{" "}
            </div>
            <div className="message-sms" title={props.messageData.message}>{props.messageData.message}</div>
          </div>
        </IonItem>
        {props.permissions.messagePermission && (
          <IonButton
            className="sb-ok-button"
            shape="round"
            onClick={() => onRemoveMesageCard()}
          >
            OK
          </IonButton>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default SBoardMessageCard;
